// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"StrainPage_heroImage__q__mq","heroImageContainer":"StrainPage_heroImageContainer__jDpn1","leftHalfSpacing":"StrainPage_leftHalfSpacing__ClDsd"};